// tslint:disable:no-any
import * as React from 'react';
import Moment from 'react-moment';
import {
    DIVE_TYPES,
    DIVE_WEATHER,
    DIVE_SALINITY
} from '../constants/DiveEnums';
import { SettingsService } from '../services/SettingsService';
import { UserSettingsDTO } from '../api/index';

export class DisplayNdash extends React.Component {
    render() {
        return <span dangerouslySetInnerHTML={{ __html: '&ndash;' }} />;
    }
}

export interface IDisplayTimeByTimeStampProps {
    data: number;
    ignoreDays?: boolean;
}

export default class DisplayTimeByTimeStamp extends React.Component<
    IDisplayTimeByTimeStampProps
> {
    render() {
        var temp = this.props.data;

        const hours = Math.floor((this.props.ignoreDays === true ? temp : (temp %= 86400)) / 3600);
        let stringHours = hours.toString();
        if (hours < 10) {
            stringHours = '0' + hours;
        }

        const minutes = Math.floor((temp %= 3600) / 60);
        let stringMinutes = minutes.toString();
        if (minutes < 10) {
            stringMinutes = '0' + minutes;
        }

        const seconds = temp % 60;
        let stringSeconds = seconds.toString();
        if (seconds < 10) {
            stringSeconds = '0' + seconds;
        }

        return (
            <span>
                {stringHours}:{stringMinutes}:{stringSeconds}
            </span>
        );
    }
}

export interface IDisplayDateProps {
    data: string;
}

export class DisplayDate extends React.Component<IDisplayDateProps> {

    static getFormat() {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.dateFormat != undefined
        ) {
            if (
                settings.config.dateFormat
                    .toString().toLowerCase() == UserSettingsDTO.DateFormatEnum.YMD.toString().toLowerCase()
            ) {
                return 'Y-MM-DD';
            }
            if (
                settings.config.dateFormat
                    .toString().toLowerCase() == UserSettingsDTO.DateFormatEnum.MDY.toString().toLowerCase()
            ) {
                return 'M/D/Y';
            }
        }
        return 'D.M.Y';
    }

    render() {
        return (
            <Moment format={DisplayDate.getFormat()}>{this.props.data}</Moment>
        );
    }
}

export interface IDisplayTimeProps {
    data: string;
}
export class DisplayTime extends React.Component<IDisplayTimeProps> {
    static getFormat() {
        return 'H:mm';
    }

    render() {
        return (
            <Moment format={DisplayTime.getFormat()}>{this.props.data}</Moment>
        );
    }
}

export interface IDisplayDateTimeProps {
    data: string;
}
export class DisplayDateTime extends React.Component<IDisplayDateTimeProps> {
    static getFormat() {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.dateFormat != undefined
        ) {
            if (
                settings.config.dateFormat
                    .toString().toLowerCase() == UserSettingsDTO.DateFormatEnum.YMD.toString().toLowerCase()
            ) {
                return 'Y-MM-DD, H:mm';
            }
            if (
                settings.config.dateFormat
                    .toString().toLowerCase() == UserSettingsDTO.DateFormatEnum.MDY.toString().toLowerCase()
            ) {
                return 'M/D/Y, H:mm';
            }
        }
        return 'D.M.Y, H:mm';
    }

    render() {
        return (
            <Moment format={DisplayDateTime.getFormat()}>
                {this.props.data}
            </Moment>
        );
    }
}

export interface IDisplayDiveModeProps {
    data: string;
}
export class DisplayDiveMode extends React.Component<IDisplayDiveModeProps> {
    render() {
        var data = this.props.data;
        data = data.toUpperCase();

        return <span>{data}</span>;
    }
}

export interface IDisplayDepthProps {
    data: number;
}

export class DisplayDepth extends React.Component<IDisplayDepthProps> {
    static getValue(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfLength != undefined
        ) {
            if (
                settings.config.unitOfLength ==
                UserSettingsDTO.UnitOfLengthEnum.Foot
            ) {
                data = data * 3.2808399;
            }
        }

        return Number(parseFloat('' + Math.round(data * 100) / 100).toFixed(2));
    }

    static getValueReverse(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfLength != undefined
        ) {
            if (
                settings.config.unitOfLength ==
                UserSettingsDTO.UnitOfLengthEnum.Foot
            ) {
                data = data / 3.2808399;
            }
        }

        return data;
    }

    static getUnit() {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfLength != undefined
        ) {
            if (
                settings.config.unitOfLength ==
                UserSettingsDTO.UnitOfLengthEnum.Foot
            ) {
                return 'ft';
            }
        }

        return 'm';
    }

    static display(value: number) {
        const data = value;
        const unit = DisplayDepth.getUnit();

        const textNumber = parseFloat(
            '' + Math.round(data * 100) / 100
        ).toFixed(2);

        return '' + textNumber + ' ' + unit;
    }

    render() {
        // tslint:disable-next-line:triple-equals
        if (this.props.data == undefined || this.props.data === 0) {
            return <DisplayNdash />;
        }

        var data = DisplayDepth.getValue(this.props.data);
        var unit = DisplayDepth.getUnit();

        const temp = parseFloat('' + Math.round(data * 100) / 100).toFixed(2);

        return (
            <span>
                {temp} {unit}
            </span>
        );
    }
}

export interface IDisplayWeightProps {
    data: number;
}

export class DisplayWeight extends React.Component<IDisplayWeightProps> {
    static getValue(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfMass != undefined
        ) {
            if (
                settings.config.unitOfMass ==
                UserSettingsDTO.UnitOfMassEnum.Pound
            ) {
                data = data * 2.20462262;
            }
        }

        return Number(parseFloat('' + Math.round(data * 10) / 10).toFixed(1));
    }

    static getValueReverse(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfMass != undefined
        ) {
            if (
                settings.config.unitOfMass ==
                UserSettingsDTO.UnitOfMassEnum.Pound
            ) {
                data = data / 2.20462262;
            }
        }

        return data;
    }

    static getUnit() {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfMass != undefined
        ) {
            if (
                settings.config.unitOfMass ==
                UserSettingsDTO.UnitOfMassEnum.Pound
            ) {
                return 'lb';
            }
        }

        return 'kg';
    }

    render() {
        // tslint:disable-next-line:triple-equals
        if (this.props.data == undefined || this.props.data === 0) {
            return <DisplayNdash />;
        }

        var data = DisplayWeight.getValue(this.props.data);
        var unit = DisplayWeight.getUnit();

        const temp = parseFloat('' + Math.round(data * 10) / 10).toFixed(1);

        return (
            <span>
                {temp} {unit}
            </span>
        );
    }
}

export class DisplayTemp extends React.Component<{ data: number }> {
    static getValue(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfTemperature != undefined
        ) {
            if (
                settings.config.unitOfTemperature ==
                UserSettingsDTO.UnitOfTemperatureEnum.Fahrenheit
            ) {
                data = data * 1.8 + 32;
            }
        }

        return Number(parseFloat('' + Math.round(data * 10) / 10).toFixed(1));
    }

    static getValueReverse(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfTemperature != undefined
        ) {
            if (
                settings.config.unitOfTemperature ==
                UserSettingsDTO.UnitOfTemperatureEnum.Fahrenheit
            ) {
                data = ( data - 32 ) / 1.8;
            }
        }

        return data;
    }

    static getUnit() {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfTemperature != undefined
        ) {
            if (
                settings.config.unitOfTemperature ==
                UserSettingsDTO.UnitOfTemperatureEnum.Fahrenheit
            ) {
                return '°F';
            }
        }

        return '°C';
    }

    static display(value: number) {
        var data = value;
        var unit = DisplayTemp.getUnit();

        const temp = parseFloat('' + Math.round(data * 10) / 10).toFixed(1);

        return temp + ' ' + unit;
    }

    render() {
        // tslint:disable-next-line:triple-equals
        if (this.props.data == undefined || this.props.data === 0) {
            return <DisplayNdash />;
        }

        var data = DisplayTemp.getValue(this.props.data);
        var unit = DisplayTemp.getUnit();

        const temp = parseFloat('' + Math.round(data * 10) / 10).toFixed(1);

        return (
            <span>
                {temp} {unit}
            </span>
        );
    }
}

export class DisplaySalinity extends React.Component<{ data: string }> {
    render() {
        // tslint:disable-next-line:triple-equals
        if (this.props.data == undefined || this.props.data === 'unknown') {
            return <DisplayNdash />;
        }

        var data = this.props.data;

        if (DIVE_SALINITY[data] !== undefined) {
            data = DIVE_SALINITY[data];
        }

        return <span>{data}</span>;
    }
}

export class DisplayWeather extends React.Component<{ data: string }> {
    render() {
        // tslint:disable-next-line:triple-equals
        if (this.props.data == undefined || this.props.data === 'unknown') {
            return <DisplayNdash />;
        }

        var data = this.props.data;

        if (DIVE_WEATHER[data] !== undefined) {
            data = DIVE_WEATHER[data];
        }

        return <span>{data}</span>;
    }
}

export class DisplaySac extends React.Component<{ data: number; alert: boolean; sac: any; }> {

    static getValue(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfVolume != undefined
        ) {
            if (
                settings.config.unitOfVolume ==
                UserSettingsDTO.UnitOfVolumeEnum.CubicFoot
            ) {
                data = data * 0.0353146667;
            }
        }

        return Number(parseFloat('' + Math.round(data * 100) / 100).toFixed(2));
    }

    static getValueReverse(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfVolume != undefined
        ) {
            if (
                settings.config.unitOfVolume ==
                UserSettingsDTO.UnitOfVolumeEnum.CubicFoot
            ) {
                data = data / 0.0353146667;
            }
        }

        return data;
    }

    static getUnit() {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfVolume != undefined
        ) {
            if (
                settings.config.unitOfVolume ==
                UserSettingsDTO.UnitOfVolumeEnum.CubicFoot
            ) {
                return 'ft³';
            }
        }

        return 'l';
    }

    render() {
        var data = DisplaySac.getValue(this.props.data);
        var unit = DisplaySac.getUnit();
        var tooltip = '';

        const temp = parseFloat('' + Math.round(data * 100) / 100).toFixed(2);

        if (this.props.alert) {
            if (this.props.sac.sourceDataIncomplete === true) {
                tooltip = 'Source data incomplete';
            } else if (
                this.props.sac.sourceDataInvalid === true ||
                this.props.sac.isInvalid === true
            ) {
                tooltip = 'Source data invalid';
            } else {
                tooltip = 'SAC computation was not successful';
            }
        }

        return (
            <span>
                {temp} {unit}/min
                {this.props.alert && (
                    <i className="alert">
                        <i className="tooltip">
                            <span className="tooltiptext tooltip-top">
                                {tooltip}
                            </span>
                        </i>
                    </i>
                )}
            </span>
        );
    }
}

export class DisplayPartner extends React.Component<{ data: string }> {
    render() {
        // tslint:disable-next-line:triple-equals
        if (this.props.data == undefined || this.props.data === '') {
            return <DisplayNdash />;
        }

        var data = this.props.data;

        return <span>{data}</span>;
    }
}

export class DisplayMixture extends React.Component<{ data: any }> {
    render() {
        var name = '-';
        var data = this.props.data;

        switch (data.mixType) {
            case 'air':
            case 'oxygen':
                name = data.mixType.substring(0, 3).toUpperCase();
                break;
            case 'ean':
                name = 'EAN ' + data.o2;
                break;
            case 'trimix':
                name = 'TMX ' + data.o2 + '/' + data.he;
                break;
            default:
                name = '';
        }

        return <strong className="mixTypeName">{name}</strong>;
    }
}

export class DisplayMixTank extends React.Component<{ data: number }> {
    static getValue(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfVolume != undefined
        ) {
            if (
                settings.config.unitOfVolume ==
                UserSettingsDTO.UnitOfVolumeEnum.CubicFoot
            ) {
                data = data * 0.0353146667;
            }
        }

        return Number((Math.round(data * 10) / 10).toFixed(1));
    }

    static getUnit() {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfVolume != undefined
        ) {
            if (
                settings.config.unitOfVolume ==
                UserSettingsDTO.UnitOfVolumeEnum.CubicFoot
            ) {
                return 'ft³';
            }
        }

        return 'l';
    }

    render() {
        // tslint:disable-next-line:triple-equals
        if (this.props.data == undefined || this.props.data === 0) {
            return <DisplayNdash />;
        }

        var data = DisplayMixTank.getValue(this.props.data);
        var unit = DisplayMixTank.getUnit();

        const temp = parseFloat('' + Math.round(data * 10) / 10).toFixed(1);

        return (
            <span>
                {temp} {unit}
            </span>
        );
    }
}

export class DisplayDiveTypes extends React.Component<{ data: any }> {
    render() {
        // tslint:disable-next-line:triple-equals
        if (this.props.data == undefined || this.props.data === 0) {
            return <DisplayNdash />;
        }

        var data = '';
        this.props.data.map((type: any) => {
            data += (data !== '' ? ', ' : '') + DIVE_TYPES[type];
            return null;
        });

        return <span>{data}</span>;
    }
}

export class DisplayMixPressure extends React.Component<{ data: number }> {

    static getValue(data: number) {
        let res = data;
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfPressure != undefined
        ) {
            if (
                settings.config.unitOfPressure ===
                UserSettingsDTO.UnitOfPressureEnum.PoundPerSquareInch
                ) {
                    res = (data * 14.5037738);
                }
            }

        return res;
    }

    static getValueReverse(data: number) {
        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfPressure != undefined
        ) {
            if (
                settings.config.unitOfPressure ===
                UserSettingsDTO.UnitOfPressureEnum.PoundPerSquareInch
            ) {
                data = data / 14.5037738;
            }
        }

        return data;
    }

    static getUnit(force: string | null = null) {
        if (force) {
            return force;
        }

        const settings = SettingsService.getInstance().getSettings();
        if (
            settings != undefined &&
            settings.config != undefined &&
            settings.config.unitOfPressure != undefined
        ) {
            if (
                settings.config.unitOfPressure ==
                UserSettingsDTO.UnitOfPressureEnum.PoundPerSquareInch
            ) {
                return 'psi';
            }
        }

        return 'bar';
    }

    static display = (forceUnit: string| null = null ) => (value: number) => {
        var data = value;
        var unit = DisplayMixPressure.getUnit(forceUnit);

        const temp = parseFloat('' + Math.round(data * 10) / 10).toFixed(1);

        return temp + ' ' + unit;
    }

    render() {
        // tslint:disable-next-line:triple-equals
        if (this.props.data == undefined || this.props.data === 0) {
            return <DisplayNdash />;
        }

        var data = DisplayMixPressure.getValue(this.props.data);
        var unit = DisplayMixPressure.getUnit();

        const temp = parseFloat('' + Math.round(data * 10) / 10).toFixed(1);

        return (
            <span>
                {temp} {unit}
            </span>
        );
    }
}

export interface IDisplayGPS {
    lat: any;
    lng: any;
}
export class DisplayGPS extends React.Component<IDisplayGPS> {
    private slat: string = '';
    private slng: string = '';

    constructor(props: IDisplayGPS) {
        super(props);

        var latitude = this.toDegreesMinutesAndSeconds(this.props.lat);
        var latitudeCardinal = parseInt(this.props.lat, 10) >= 0 ? 'N' : 'S';

        var longitude = this.toDegreesMinutesAndSeconds(this.props.lng);
        var longitudeCardinal = parseInt(this.props.lng, 10) >= 0 ? 'E' : 'W';

        this.slat = latitude + ' ' + latitudeCardinal;
        this.slng = longitude + ' ' + longitudeCardinal;
    }

    formatNumber(num: number, decimals: boolean = false) {
        var dec = num - Math.floor(num);
        num = num - dec;
        var formattedNumber = ('0' + num).slice(-2);
        if (decimals !== false) {
            dec = dec * 10;
            formattedNumber =
                formattedNumber + '.' + Math.round(dec).toString();
        }
        return formattedNumber;
    }

    toDegreesMinutesAndSeconds(coordinate: number) {
        var absolute = Math.abs(coordinate);
        var degrees = Math.floor(absolute);

        var minutesNotTruncated = (absolute - degrees) * 60;

        var minutes = this.formatNumber(Math.floor(minutesNotTruncated));
        var seconds = this.formatNumber(
            // tslint:disable-next-line:radix
            Math.floor((minutesNotTruncated - parseInt(minutes)) * 60 * 100) /
                100,
            true
        );

        // tslint:disable-next-line:quotemark
        return degrees + '°' + minutes + "'" + seconds + '"';
    }

    render() {
        if (
            this.props.lat == undefined ||
            this.props.lat === 0 ||
            this.props.lng == undefined ||
            this.props.lng === 0
        ) {
            return <DisplayNdash />;
        }

        return (
            <span>
                {this.slat}
                <br />
                {this.slng}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Display.tsx